// Pure HFv4 skill-score math. Call from ProgressReportHFv4 containers, not from
// `accessors.js` — that module is shared with legacy IDP views.
// Import as a namespace (`import * as skillScoreHFv4`) — these names deliberately
// mirror their non-HFv4 counterparts in `accessors.js`.
import is from 'is_js';

function resolveSkillPercentage(skillResult) {
  const { layeredScore, layeredFullMark } = skillResult;
  if (is.number(layeredScore) && is.number(layeredFullMark) && layeredFullMark > 0) {
    return (layeredScore / layeredFullMark) * 100;
  }
  if (is.number(skillResult.score)) return skillResult.score * 100;
  return null;
}

export function formatSkillScore(skillResult, defaultText = '–') {
  const percentage = resolveSkillPercentage(skillResult);
  if (percentage === null) return defaultText;
  return `${Math.round(percentage)}%`;
}

export function calculateQuizAverageScore(skillResults) {
  if (! skillResults || skillResults.size <= 0) return null;

  let totalScore = 0;
  let scoreCount = 0;
  skillResults.forEach((skillResult) => {
    const percentage = resolveSkillPercentage(skillResult);
    if (percentage !== null) {
      totalScore += Math.min(100, percentage);
      scoreCount += 1;
    }
  });

  if (scoreCount === 0) return null;
  return Math.round(totalScore / scoreCount);
}

const SPEAKING_1 = 'Speaking 1';
const SPEAKING_2 = 'Speaking 2';
export const MERGED_SPEAKING_NAME = 'Speaking 1 & 2';

function isSplitSpeaking(skillResult) {
  return skillResult.name === SPEAKING_1 || skillResult.name === SPEAKING_2;
}

// HFv4 units report Speaking 1 alone (unit 6 / unit 12) or Speaking 1 + Speaking 2.
// Both shapes are presented as a single Speaking 1 & 2 score, averaged when both are scored.
export function mergeSpeakingSkillResults(skillResults) {
  if (! skillResults || ! skillResults.size) return skillResults;

  const firstSpeakingIndex = skillResults.findIndex(isSplitSpeaking);
  if (firstSpeakingIndex < 0) return skillResults;

  const speakingResults = skillResults.filter(isSplitSpeaking);
  const percentages = speakingResults
    .map(resolveSkillPercentage)
    .filter((percentage) => percentage !== null);
  const averagePercentage = percentages.size > 0 ?
    percentages.reduce((total, percentage) => total + percentage, 0) / percentages.size :
    null;
  const hasScore = averagePercentage !== null;

  const mergedSpeaking = speakingResults.first()
    .set('name', MERGED_SPEAKING_NAME)
    .set('score', hasScore ? averagePercentage / 100 : null)
    .set('layeredScore', hasScore ? averagePercentage : null)
    .set('layeredFullMark', hasScore ? 100 : null);

  return skillResults
    .filterNot(isSplitSpeaking)
    .insert(firstSpeakingIndex, mergedSpeaking);
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/skillScoreHFv4.js